export interface Permissies {
    maximaal_bedrag: Geld;
    toegestane_operaties: Operaties;
}

export interface LimietWaarde {
    huidig: Geld;
    maximaal: Geld;
}

export interface Limiet {
    bedrag_inkomend_maandelijks: LimietWaarde;
}

export interface Operaties {
    operaties: Operatie[];
}

export interface Operatie {
    naam: string;
    toegestaan: boolean;
    verklaringen?: Verklaring[];
}

export interface LijstVanBetaalverzoeken {
    next_cursor?: string;
    betaalverzoeken: Betaalverzoek[];
}

export interface Betaalverzoek {
    betaalverzoek_id?: string;
    autorisatie_code?: string;
    crediteur: Crediteur;
    bedrag: Geld;
    omschrijving: string;
    geslaagde_transacties?: number;
    aangemaakt_op?: string;
    verloopt_op?: string;
    status?: BetaalverzoekStatus;
    betaallink?: string;
    maximaal_bedrag?: Geld;
    aantal_personen?: number;
}

export interface Crediteur {
    rekening_id: string;
    iban?: string;
    weergavenaam?: string;
}

export interface Geld {
    bedrag: number;
    valuta: string;
}

export interface LijstVanBetaaltransacties {
    betaaltransacties: Betaaltransactie[];
}

export interface Betaaltransactie {
    transactie_id?: string;
    autorisatie_code: string;
    betaalverzoek_id: string;
    debiteur?: Debiteur;
    crediteur?: Crediteur;
    omschrijving?: string;
    bedrag?: Geld;
    toegangscode?: string;
    aangemaakt_op?: string;
    betaald_op?: string;
    verlopen_op?: string;
    status?: BetaaltransactieStatus;
}

export interface Debiteur {
    bic: string;
    iban?: string;
    weergavenaam?: string;
}

export enum BetaalverzoekStatus {
    OPEN = 'open',
    EXPIRED = 'verlopen',
    REMOVED = 'verwijderd'
}

export interface BetaalverzoekTotalen {
    openstaande_betaalverzoeken: number;
}

export interface IsZakelijk {
    is_zakelijk: boolean;
}

export enum BetaaltransactieStatus {
    OPEN = 'open',
    SUCCESS = 'geslaagd',
    CANCELLED = 'geannuleerd',
    EXPIRED = 'verlopen',
    FAILED = 'mislukt'
}

export enum BankToBic {
    SNS = 'SNSBNL2A',
    REB = 'RBRBNL21',
    ASN = 'ASNBNL21'
}

export enum Verklaring {
    BLOCKED_BY_SAS = 'BV_CONTRACT_BLOCKED',
    WEAK_TOKEN = 'BV_TOKEN_NOT_STRONG_ENOUGH',
    UNSUITABLE_ACCOUNT_PRODUCT_FEATURES = 'BV_UNSUITABLE_PRODUCT_FEATURES_FOR_THE_PROVIDED_ACCOUNT',
    INSUFFICIENT_ACCOUNT_ROLES = 'BV_INSUFFICIENT_ROLES_FOR_THE_PROVIDED_ACCOUNT',
    NO_SBI_OR_TRADENAME = 'BV_MISSING_SBI_OR_TRADENAME',
    BV_MONTHLY_AMOUNT_EXCEEDED = 'BV_MONTHLY_AMOUNT_EXCEEDED'
}
